import { ApiClientConfiguration } from 'api/swagger/ApiClientConfiguration';
import { ApiClientBase } from 'api/swagger/ApiClientBase';

export class ProblemDetails {
  type!: string | null;
  title!: string | null;
  status!: number | null;
  detail!: string | null;
  instance!: string | null;
  traceId!: string | null;
  customType!: string | null;
  validationErrors!: { [key: string]: [string] } | null;
  extensions!: { [key: string]: string } | null;

  constructor() {
    this.type = null;
    this.title = null;
    this.status = null;
    this.detail = null;
    this.instance = null;
    this.traceId = null;
    this.customType = null;
    this.validationErrors = null;
    this.extensions = null;
  }

  init(_data?: any) {
    if (_data) {
      for (const property in _data) {
        if (property === "type")
          this.type = _data[property];
        else if (property === "title")
          this.title = _data[property];
        else if (property === "status")
          this.status = _data[property];
        else if (property === "detail")
          this.detail = _data[property];
        else if (property === "instance")
          this.instance = _data[property];
        else if (property === "traceId")
          this.traceId = _data[property];
        else if (property === "customType")
          this.customType = _data[property];
        else if (property === "errors")
          this.validationErrors = _data[property];
        else {
          if (this.extensions === null)
            this.extensions = {} as { [key: string]: string };
          this.extensions[property] = _data[property];
        }
      }
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    data["traceId"] = this.traceId !== undefined ? this.traceId : <any>null;
    data["customType"] = this.customType !== undefined ? this.customType : <any>null;
    data["errors"] = this.validationErrors !== undefined ? this.validationErrors : <any>null;
    if (this.extensions) {
      for (let key in this.extensions) {
        if (this.extensions.hasOwnProperty(key))
          data[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
      }
    }
    return data;
  }

  clone(): ProblemDetails {
    const json = this.toJSON();
    let result = new ProblemDetails();
    result.init(json);
    return result;
  }
}
